/**
 * 수수료 업로드 검증 결과 모달 — 레거시 settlementFeeInfo 모달 포팅
 */
import { Button } from '@/shared/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/ui/dialog';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/shared/components/ui/table';
import React from 'react';

interface InvalidDrugCodesModalProps {
  open: boolean;
  codes: string[];
  onClose: () => void;
}

export const InvalidDrugCodesModal: React.FC<InvalidDrugCodesModalProps> = ({
  open,
  codes,
  onClose,
}) => (
  <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
    <DialogContent className="max-h-[80vh] max-w-lg overflow-y-auto">
      <DialogHeader>
        <DialogTitle>제품코드 오류</DialogTitle>
      </DialogHeader>
      <p className="text-sm text-muted-foreground">
        제품코드는 공백·쉼표 제거 후 정확히 9자여야 합니다. 아래 목록을 확인해
        수정한 뒤 다시 업로드해 주세요.
      </p>
      <div className="rounded-lg border">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>문제 제품코드</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {codes.map((code) => (
              <TableRow key={code}>
                <TableCell>{code}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <DialogFooter>
        <Button onClick={onClose}>확인</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

interface InvalidPharmaDrugCodesModalProps {
  open: boolean;
  drugCodes: string[];
  onClose: () => void;
}

export const InvalidPharmaDrugCodesModal: React.FC<
  InvalidPharmaDrugCodesModalProps
> = ({ open, drugCodes, onClose }) => (
  <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
    <DialogContent className="max-h-[80vh] max-w-lg overflow-y-auto">
      <DialogHeader>
        <DialogTitle>제약사 코드 오류</DialogTitle>
      </DialogHeader>
      <p className="text-sm text-muted-foreground">
        제약사 코드에 오류가 있는 의약품이 있습니다. 아래 코드의 제약사 코드를
        확인 후 다시 업로드해 주세요.
      </p>
      <div className="rounded-lg border">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>오류 의약품 코드</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {drugCodes.map((code) => (
              <TableRow key={code}>
                <TableCell>{code}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <DialogFooter>
        <Button onClick={onClose}>확인</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

interface UnknownPharmaModalProps {
  open: boolean;
  pharmaNames: string[];
  drugCodes: string[];
  onClose: () => void;
}

export const UnknownPharmaModal: React.FC<UnknownPharmaModalProps> = ({
  open,
  pharmaNames,
  drugCodes,
  onClose,
}) => (
  <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
    <DialogContent className="max-h-[80vh] max-w-2xl overflow-y-auto">
      <DialogHeader>
        <DialogTitle>제약사명 확인 필요</DialogTitle>
      </DialogHeader>
      <p className="text-sm text-muted-foreground">
        ADMIN에 등록되지 않았거나 이름이 일치하지 않는 제약사가 있습니다.
        제약사 관리에서 이름을 확인·등록한 뒤 다시 업로드해 주세요.
      </p>
      <div className="grid gap-4 md:grid-cols-2">
        <div className="rounded-lg border">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>확인 필요 제약사명</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {pharmaNames.map((name) => (
                <TableRow key={name}>
                  <TableCell>{name}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
        <div className="rounded-lg border">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>매칭 실패 제품코드</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {drugCodes.map((code) => (
                <TableRow key={code}>
                  <TableCell>{code}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
      <DialogFooter>
        <Button onClick={onClose}>확인</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
